
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExpandArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 12,
  width: 12,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "2.4 2.4 11.2 11.2"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.286 3H3v4.286M8 8 3 3M8.714 13H13V8.714M8 8l5 5",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg height=\"12\" width=\"12\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"2.4 2.4 11.2 11.2\"> <path d=\"M7.28571 3H3V7.28571\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> <path d=\"M8 8L3 3\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> <path d=\"M8.71429 13L13 13L13 8.71429\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> <path d=\"M8 8L13 13\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> \r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/expand-arrow.1cab8802e7295d7a2cba81e27e11573b.svg"),
        {
          React: SvgExpandArrow,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      